import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import async from './components/async';

import { HomologatorConsumer } from './components/homologator-context';

const component = connect(({ oidc }) => ({
  authenticated: !!oidc.user,
  user: oidc.user
}));

export default withRouter(component(function Routes({ authenticated}) {
  return authenticated ? valid : invalid;
}));

const valid = <Switch>
  <Route path={'/'} exact component={async(() => import('./pages/index'))} />
  <Route path={'/signout'} component={async(() => import('./pages/signOut'))} />

  <Route path={'/consulta'} exact component={async(() => import('./pages/query'))} />

  <Route path={'/consulta/:id'} exact component={async(() => import('./pages/query/details'))} />

  <Route
    exact
    path={'/consulta/:id/retificacao'}
    component={async(() => import('./pages/rectification'))}
  />

  <Route
    exact
    path={'/motorista/recadastro'}
    component={async(() => import('./pages/listings/drivers'))}
  />

  <Route
    exact
    path={'/veiculo/recadastro'}
    component={async(() => import('./pages/listings/vehicles'))}
  />

  <Route
    exact
    path={'/proprietario/cadastro'}
    component={async(() => import('./pages/registrations/owner'))}
  />

  <Route
    path={'/proprietario/:id/editar'}
    component={async(() => import('./pages/registrations/owner'))}
  />

  <Route
    exact
    path={'/motorista/cadastro'}
    component={async(() => import('./pages/registrations/driver'))}
  />

  <Route
    exact
    path={'/motorista/:id/editar'}
    component={async(() => import('./pages/registrations/driver'))}
  />

  <Route
    exact
    path={'/veiculo/cadastro'}
    component={async(() => import('./pages/registrations/vehicle'))}
  />

  <Route
    exact
    path={'/veiculo/:id/editar'}
    component={async(() => import('./pages/registrations/vehicle'))}
  />

  <Route
    exact
    path={'/relatorio'}
    component={async(() => import('./pages/report'))}
  />

  <Route
    exact
    path={'/relatorio/exportar'}
    component={async(() => import('./pages/report/print'))}
  />

  <HomologatorConsumer>
    {({ hasCertificateManagement })=> hasCertificateManagement &&
      (
        <Route
          exact
          path={'/certificados'}
          component={async(() => import('./pages/certificates'))}
        />
      )
    }
  </HomologatorConsumer>
  <HomologatorConsumer>
    {({ hasIntegratedQuery })=> hasIntegratedQuery &&
      (
        <Route
          exact
          path={'/integradas/recadastro'}
          component={async(() => import('./pages/listings/integrated'))}
        />
      )
    }
  </HomologatorConsumer>
</Switch>;

const invalid = <Switch>
  <Route path={'/callback'} component={async(() => import('./pages/callback'))} />
  <Route path={'/signout'} component={async(() => import('./pages/signOut'))} />
  <Route path={'/'} component={async(() => import('./pages/signIn'))} />
</Switch>;
